const data = [{
  Year: 2002,
  Sport: 'Football',
  'Net ($)': -60328.0,
  'Net ($M)': -0.060328,
  'Net ($ in 2024)': -104970.7199999988,
  'Net ($M in 2024)': -0.10497072,
}, {
  Year: 2002,
  Sport: "Men's basketball",
  'Net ($)': 1843722.0,
  'Net ($M)': 1.843722,
  'Net ($ in 2024)': 3208076.2800000003,
  'Net ($M in 2024)': 3.20807628,
}, {
  Year: 2002,
  Sport: 'Non-program specific',
  'Net ($)': 1475843.9900000002,
  'Net ($M)': 1.47584399,
  'Net ($ in 2024)': 2567968.5426000003,
  'Net ($M in 2024)': 2.5679685426,
}, {
  Year: 2002,
  Sport: "Other men's sports",
  'Net ($)': -1719639.0,
  'Net ($M)': -1.719639,
  'Net ($ in 2024)': -2992171.8600000003,
  'Net ($M in 2024)': -2.99217186,
}, {
  Year: 2002,
  Sport: "Other women's sports",
  'Net ($)': -1357092.0,
  'Net ($M)': -1.357092,
  'Net ($ in 2024)': -2361340.0799999991,
  'Net ($M in 2024)': -2.36134008,
}, {
  Year: 2002,
  Sport: "Women's basketball",
  'Net ($)': -429266.0,
  'Net ($M)': -0.429266,
  'Net ($ in 2024)': -746922.8399999999,
  'Net ($M in 2024)': -0.74692284,
}, {
  Year: 2003,
  Sport: 'Football',
  'Net ($)': 1836986.0,
  'Net ($M)': 1.836986,
  'Net ($ in 2024)': 3122876.200000003,
  'Net ($M in 2024)': 3.1228762,
}, {
  Year: 2003,
  Sport: "Men's basketball",
  'Net ($)': 2369488.0,
  'Net ($M)': 2.369488,
  'Net ($ in 2024)': 4028129.6000000006,
  'Net ($M in 2024)': 4.0281296,
}, {
  Year: 2003,
  Sport: 'Non-program specific',
  'Net ($)': -3393552.0,
  'Net ($M)': -3.393552,
  'Net ($ in 2024)': -5769038.3999999948,
  'Net ($M in 2024)': -5.7690384,
}, {
  Year: 2003,
  Sport: "Other men's sports",
  'Net ($)': -2154200.0,
  'Net ($M)': -2.1542,
  'Net ($ in 2024)': -3662140.0,
  'Net ($M in 2024)': -3.66214,
}, {
  Year: 2003,
  Sport: "Other women's sports",
  'Net ($)': -2701720.0,
  'Net ($M)': -2.70172,
  'Net ($ in 2024)': -4592924.0000000009,
  'Net ($M in 2024)': -4.592924,
}, {
  Year: 2003,
  Sport: "Women's basketball",
  'Net ($)': -364887.0,
  'Net ($M)': -0.364887,
  'Net ($ in 2024)': -620307.8999999999,
  'Net ($M in 2024)': -0.6203079,
}, {
  Year: 2004,
  Sport: 'Football',
  'Net ($)': 2869654.8499999996,
  'Net ($M)': 2.86965485,
  'Net ($ in 2024)': 4734930.5025000013,
  'Net ($M in 2024)': 4.7349305025,
}, {
  Year: 2004,
  Sport: "Men's basketball",
  'Net ($)': 3043649.0,
  'Net ($M)': 3.043649,
  'Net ($ in 2024)': 5022020.8500000006,
  'Net ($M in 2024)': 5.02202085,
}, {
  Year: 2004,
  Sport: 'Non-program specific',
  'Net ($)': -4706128.0,
  'Net ($M)': -4.706128,
  'Net ($ in 2024)': -7765111.1999999993,
  'Net ($M in 2024)': -7.7651112,
}, {
  Year: 2004,
  Sport: "Other men's sports",
  'Net ($)': -2144093.0,
  'Net ($M)': -2.144093,
  'Net ($ in 2024)': -3537753.4500000002,
  'Net ($M in 2024)': -3.53775345,
}, {
  Year: 2004,
  Sport: "Other women's sports",
  'Net ($)': -784785.6699999999,
  'Net ($M)': -0.78478567,
  'Net ($ in 2024)': -1294896.3554999996,
  'Net ($M in 2024)': -1.2948963555,
}, {
  Year: 2004,
  Sport: "Women's basketball",
  'Net ($)': -473970.0,
  'Net ($M)': -0.47397,
  'Net ($ in 2024)': -782050.5,
  'Net ($M in 2024)': -0.7820505,
}, {
  Year: 2005,
  Sport: 'Football',
  'Net ($)': 3346008.0,
  'Net ($M)': 3.346008,
  'Net ($ in 2024)': 5387072.8800000027,
  'Net ($M in 2024)': 5.38707288,
}, {
  Year: 2005,
  Sport: "Men's basketball",
  'Net ($)': 2831243.0,
  'Net ($M)': 2.831243,
  'Net ($ in 2024)': 4558301.2300000004,
  'Net ($M in 2024)': 4.55830123,
}, {
  Year: 2005,
  Sport: 'Non-program specific',
  'Net ($)': -6820722.0,
  'Net ($M)': -6.820722,
  'Net ($ in 2024)': -10981362.4200000018,
  'Net ($M in 2024)': -10.98136242,
}, {
  Year: 2005,
  Sport: "Other men's sports",
  'Net ($)': -2943136.0,
  'Net ($M)': -2.943136,
  'Net ($ in 2024)': -4738448.96,
  'Net ($M in 2024)': -4.73844896,
}, {
  Year: 2005,
  Sport: "Other women's sports",
  'Net ($)': -3623150.0,
  'Net ($M)': -3.62315,
  'Net ($ in 2024)': -5833271.5000000009,
  'Net ($M in 2024)': -5.8332715,
}, {
  Year: 2005,
  Sport: "Women's basketball",
  'Net ($)': -677853.0,
  'Net ($M)': -0.677853,
  'Net ($ in 2024)': -1091343.3300000001,
  'Net ($M in 2024)': -1.09134333,
}, {
  Year: 2006,
  Sport: 'Football',
  'Net ($)': 5905947.0,
  'Net ($M)': 5.905947,
  'Net ($ in 2024)': 9095158.379999999,
  'Net ($M in 2024)': 9.09515838,
}, {
  Year: 2006,
  Sport: "Men's basketball",
  'Net ($)': 2338865.0,
  'Net ($M)': 2.338865,
  'Net ($ in 2024)': 3601852.0999999987,
  'Net ($M in 2024)': 3.6018521,
}, {
  Year: 2006,
  Sport: 'Non-program specific',
  'Net ($)': -5655583.0,
  'Net ($M)': -5.655583,
  'Net ($ in 2024)': -8709597.8200000003,
  'Net ($M in 2024)': -8.70959782,
}, {
  Year: 2006,
  Sport: "Other men's sports",
  'Net ($)': -3148713.0,
  'Net ($M)': -3.148713,
  'Net ($ in 2024)': -4849018.0199999996,
  'Net ($M in 2024)': -4.84901802,
}, {
  Year: 2006,
  Sport: "Other women's sports",
  'Net ($)': -3766766.0,
  'Net ($M)': -3.766766,
  'Net ($ in 2024)': -5800819.6400000006,
  'Net ($M in 2024)': -5.80081964,
}, {
  Year: 2006,
  Sport: "Women's basketball",
  'Net ($)': -952031.0,
  'Net ($M)': -0.952031,
  'Net ($ in 2024)': -1466127.7400000002,
  'Net ($M in 2024)': -1.46612774,
}, {
  Year: 2007,
  Sport: 'Football',
  'Net ($)': 8784370.0,
  'Net ($M)': 8.78437,
  'Net ($ in 2024)': 13176555.0,
  'Net ($M in 2024)': 13.176555,
}, {
  Year: 2007,
  Sport: "Men's basketball",
  'Net ($)': 2112161.0,
  'Net ($M)': 2.112161,
  'Net ($ in 2024)': 3168241.5,
  'Net ($M in 2024)': 3.1682415,
}, {
  Year: 2007,
  Sport: 'Non-program specific',
  'Net ($)': -5499875.0,
  'Net ($M)': -5.499875,
  'Net ($ in 2024)': -8249812.5,
  'Net ($M in 2024)': -8.2498125,
}, {
  Year: 2007,
  Sport: "Other men's sports",
  'Net ($)': -1914269.0,
  'Net ($M)': -1.914269,
  'Net ($ in 2024)': -2871403.5,
  'Net ($M in 2024)': -2.8714035,
}, {
  Year: 2007,
  Sport: "Other women's sports",
  'Net ($)': -3171242.0,
  'Net ($M)': -3.171242,
  'Net ($ in 2024)': -4756863.0,
  'Net ($M in 2024)': -4.756863,
}, {
  Year: 2007,
  Sport: "Women's basketball",
  'Net ($)': -311143.0,
  'Net ($M)': -0.311143,
  'Net ($ in 2024)': -466714.5,
  'Net ($M in 2024)': -0.4667145,
}, {
  Year: 2008,
  Sport: 'Football',
  'Net ($)': 12562636.0,
  'Net ($M)': 12.562636,
  'Net ($ in 2024)': 17964569.4800000004,
  'Net ($M in 2024)': 17.96456948,
}, {
  Year: 2008,
  Sport: "Men's basketball",
  'Net ($)': 1673282.0,
  'Net ($M)': 1.673282,
  'Net ($ in 2024)': 2392793.2599999988,
  'Net ($M in 2024)': 2.39279326,
}, {
  Year: 2008,
  Sport: 'Non-program specific',
  'Net ($)': -5544563.0,
  'Net ($M)': -5.544563,
  'Net ($ in 2024)': -7928725.0899999999,
  'Net ($M in 2024)': -7.92872509,
}, {
  Year: 2008,
  Sport: "Other men's sports",
  'Net ($)': -3474628.0,
  'Net ($M)': -3.474628,
  'Net ($ in 2024)': -4968718.04,
  'Net ($M in 2024)': -4.96871804,
}, {
  Year: 2008,
  Sport: "Other women's sports",
  'Net ($)': -4247396.0,
  'Net ($M)': -4.247396,
  'Net ($ in 2024)': -6073776.2800000003,
  'Net ($M in 2024)': -6.07377628,
}, {
  Year: 2008,
  Sport: "Women's basketball",
  'Net ($)': -918581.0,
  'Net ($M)': -0.918581,
  'Net ($ in 2024)': -1313570.8299999996,
  'Net ($M in 2024)': -1.31357083,
}, {
  Year: 2009,
  Sport: 'Football',
  'Net ($)': 8624473.0,
  'Net ($M)': 8.624473,
  'Net ($ in 2024)': 12505485.8499999978,
  'Net ($M in 2024)': 12.50548585,
}, {
  Year: 2009,
  Sport: "Men's basketball",
  'Net ($)': 1035218.0,
  'Net ($M)': 1.035218,
  'Net ($ in 2024)': 1501066.1000000006,
  'Net ($M in 2024)': 1.5010661,
}, {
  Year: 2009,
  Sport: 'Non-program specific',
  'Net ($)': 1364104.0,
  'Net ($M)': 1.364104,
  'Net ($ in 2024)': 1977950.8000000045,
  'Net ($M in 2024)': 1.9779508,
}, {
  Year: 2009,
  Sport: "Other men's sports",
  'Net ($)': -3477234.0,
  'Net ($M)': -3.477234,
  'Net ($ in 2024)': -5041989.2999999989,
  'Net ($M in 2024)': -5.0419893,
}, {
  Year: 2009,
  Sport: "Other women's sports",
  'Net ($)': -6880391.0,
  'Net ($M)': -6.880391,
  'Net ($ in 2024)': -9976566.9499999993,
  'Net ($M in 2024)': -9.97656695,
}, {
  Year: 2009,
  Sport: "Women's basketball",
  'Net ($)': -2255335.0,
  'Net ($M)': -2.255335,
  'Net ($ in 2024)': -3270235.75,
  'Net ($M in 2024)': -3.27023575,
}, {
  Year: 2010,
  Sport: 'Football',
  'Net ($)': 7026079.0,
  'Net ($M)': 7.026079,
  'Net ($ in 2024)': 10047292.9699999988,
  'Net ($M in 2024)': 10.04729297,
}, {
  Year: 2010,
  Sport: "Men's basketball",
  'Net ($)': 1150529.0,
  'Net ($M)': 1.150529,
  'Net ($ in 2024)': 1645256.4699999997,
  'Net ($M in 2024)': 1.64525647,
}, {
  Year: 2010,
  Sport: 'Non-program specific',
  'Net ($)': -1408338.370000001,
  'Net ($M)': -1.40833837,
  'Net ($ in 2024)': -2013923.8690999895,
  'Net ($M in 2024)': -2.0139238691,
}, {
  Year: 2010,
  Sport: "Other men's sports",
  'Net ($)': -3670178.0,
  'Net ($M)': -3.670178,
  'Net ($ in 2024)': -5248354.54,
  'Net ($M in 2024)': -5.24835454,
}, {
  Year: 2010,
  Sport: "Other women's sports",
  'Net ($)': -2819943.7300000004,
  'Net ($M)': -2.81994373,
  'Net ($ in 2024)': -4032519.5339000002,
  'Net ($M in 2024)': -4.0325195339,
}, {
  Year: 2010,
  Sport: "Women's basketball",
  'Net ($)': -797253.0,
  'Net ($M)': -0.797253,
  'Net ($ in 2024)': -1140071.7899999996,
  'Net ($M in 2024)': -1.14007179,
}, {
  Year: 2011,
  Sport: 'Football',
  'Net ($)': 6930135.0,
  'Net ($M)': 6.930135,
  'Net ($ in 2024)': 9563586.3000000007,
  'Net ($M in 2024)': 9.5635863,
}, {
  Year: 2011,
  Sport: "Men's basketball",
  'Net ($)': 1525500.0,
  'Net ($M)': 1.5255,
  'Net ($ in 2024)': 2105189.9999999991,
  'Net ($M in 2024)': 2.10519,
}, {
  Year: 2011,
  Sport: 'Non-program specific',
  'Net ($)': 3797223.0,
  'Net ($M)': 3.797223,
  'Net ($ in 2024)': 5240167.7400000058,
  'Net ($M in 2024)': 5.24016774,
}, {
  Year: 2011,
  Sport: "Other men's sports",
  'Net ($)': -3091346.0,
  'Net ($M)': -3.091346,
  'Net ($ in 2024)': -4266057.4800000004,
  'Net ($M in 2024)': -4.26605748,
}, {
  Year: 2011,
  Sport: "Other women's sports",
  'Net ($)': -7041644.0,
  'Net ($M)': -7.041644,
  'Net ($ in 2024)': -9717468.7199999988,
  'Net ($M in 2024)': -9.71746872,
}, {
  Year: 2011,
  Sport: "Women's basketball",
  'Net ($)': -1938702.0,
  'Net ($M)': -1.938702,
  'Net ($ in 2024)': -2675408.7599999998,
  'Net ($M in 2024)': -2.67540876,
}, {
  Year: 2012,
  Sport: 'Football',
  'Net ($)': 4010174.3599999994,
  'Net ($M)': 4.01017436,
  'Net ($ in 2024)': 5453837.1295999959,
  'Net ($M in 2024)': 5.4538371296,
}, {
  Year: 2012,
  Sport: "Men's basketball",
  'Net ($)': 1598225.0999999996,
  'Net ($M)': 1.5982251,
  'Net ($ in 2024)': 2173586.1359999999,
  'Net ($M in 2024)': 2.173586136,
}, {
  Year: 2012,
  Sport: 'Non-program specific',
  'Net ($)': -4476389.1300000008,
  'Net ($M)': -4.47638913,
  'Net ($ in 2024)': -6087889.2168000005,
  'Net ($M in 2024)': -6.0878892168,
}, {
  Year: 2012,
  Sport: "Other men's sports",
  'Net ($)': -302656.5300000012,
  'Net ($M)': -0.30265653,
  'Net ($ in 2024)': -411612.8807999995,
  'Net ($M in 2024)': -0.4116128808,
}, {
  Year: 2012,
  Sport: "Other women's sports",
  'Net ($)': -572133.2200000007,
  'Net ($M)': -0.57213322,
  'Net ($ in 2024)': -778101.1792000011,
  'Net ($M in 2024)': -0.7781011792,
}, {
  Year: 2012,
  Sport: "Women's basketball",
  'Net ($)': -120298.8599999999,
  'Net ($M)': -0.12029886,
  'Net ($ in 2024)': -163606.4495999999,
  'Net ($M in 2024)': -0.1636064496,
}, {
  Year: 2013,
  Sport: 'Football',
  'Net ($)': 9539191.0,
  'Net ($M)': 9.539191,
  'Net ($ in 2024)': 12782515.9399999976,
  'Net ($M in 2024)': 12.78251594,
}, {
  Year: 2013,
  Sport: "Men's basketball",
  'Net ($)': 3090122.0,
  'Net ($M)': 3.090122,
  'Net ($ in 2024)': 4140763.4800000004,
  'Net ($M in 2024)': 4.14076348,
}, {
  Year: 2013,
  Sport: 'Non-program specific',
  'Net ($)': 1710982.0,
  'Net ($M)': 1.710982,
  'Net ($ in 2024)': 2292715.8800000027,
  'Net ($M in 2024)': 2.29271588,
}, {
  Year: 2013,
  Sport: "Other men's sports",
  'Net ($)': -2871967.0,
  'Net ($M)': -2.871967,
  'Net ($ in 2024)': -3848435.7800000012,
  'Net ($M in 2024)': -3.84843578,
}, {
  Year: 2013,
  Sport: "Other women's sports",
  'Net ($)': -8098393.0,
  'Net ($M)': -8.098393,
  'Net ($ in 2024)': -10851846.620000001,
  'Net ($M in 2024)': -10.85184662,
}, {
  Year: 2013,
  Sport: "Women's basketball",
  'Net ($)': -1889511.0,
  'Net ($M)': -1.889511,
  'Net ($ in 2024)': -2531944.7400000002,
  'Net ($M in 2024)': -2.53194474,
}, {
  Year: 2014,
  Sport: 'Football',
  'Net ($)': 144735.0,
  'Net ($M)': 0.144735,
  'Net ($ in 2024)': 189602.8500000015,
  'Net ($M in 2024)': 0.18960285,
}, {
  Year: 2014,
  Sport: "Men's basketball",
  'Net ($)': 3226164.0,
  'Net ($M)': 3.226164,
  'Net ($ in 2024)': 4226274.8399999999,
  'Net ($M in 2024)': 4.22627484,
}, {
  Year: 2014,
  Sport: 'Non-program specific',
  'Net ($)': 6854324.0,
  'Net ($M)': 6.854324,
  'Net ($ in 2024)': 8979164.4400000051,
  'Net ($M in 2024)': 8.97916444,
}, {
  Year: 2014,
  Sport: "Other men's sports",
  'Net ($)': -2939223.0,
  'Net ($M)': -2.939223,
  'Net ($ in 2024)': -3850382.1300000008,
  'Net ($M in 2024)': -3.85038213,
}, {
  Year: 2014,
  Sport: "Other women's sports",
  'Net ($)': -8830177.0,
  'Net ($M)': -8.830177,
  'Net ($ in 2024)': -11567531.870000001,
  'Net ($M in 2024)': -11.56753187,
}, {
  Year: 2014,
  Sport: "Women's basketball",
  'Net ($)': -1785191.0,
  'Net ($M)': -1.785191,
  'Net ($ in 2024)': -2338600.21,
  'Net ($M in 2024)': -2.33860021,
}, {
  Year: 2015,
  Sport: 'Football',
  'Net ($)': 12298264.0,
  'Net ($M)': 12.298264,
  'Net ($ in 2024)': 16110725.8400000036,
  'Net ($M in 2024)': 16.11072584,
}, {
  Year: 2015,
  Sport: "Men's basketball",
  'Net ($)': 2511158.0,
  'Net ($M)': 2.511158,
  'Net ($ in 2024)': 3289616.9800000004,
  'Net ($M in 2024)': 3.28961698,
}, {
  Year: 2015,
  Sport: 'Non-program specific',
  'Net ($)': -7798608.0,
  'Net ($M)': -7.798608,
  'Net ($ in 2024)': -10216176.4800000042,
  'Net ($M in 2024)': -10.21617648,
}, {
  Year: 2015,
  Sport: "Other men's sports",
  'Net ($)': -3704959.0,
  'Net ($M)': -3.704959,
  'Net ($ in 2024)': -4853496.2899999991,
  'Net ($M in 2024)': -4.85349629,
}, {
  Year: 2015,
  Sport: "Other women's sports",
  'Net ($)': -9605179.0,
  'Net ($M)': -9.605179,
  'Net ($ in 2024)': -12582784.4900000021,
  'Net ($M in 2024)': -12.58278449,
}, {
  Year: 2015,
  Sport: "Women's basketball",
  'Net ($)': -2177314.0,
  'Net ($M)': -2.177314,
  'Net ($ in 2024)': -2852281.3399999999,
  'Net ($M in 2024)': -2.85228134,
}, {
  Year: 2016,
  Sport: 'Football',
  'Net ($)': 8946005.0,
  'Net ($M)': 8.946005,
  'Net ($ in 2024)': 11629806.5000000075,
  'Net ($M in 2024)': 11.6298065,
}, {
  Year: 2016,
  Sport: "Men's basketball",
  'Net ($)': -368363.0,
  'Net ($M)': -0.368363,
  'Net ($ in 2024)': -478871.9000000004,
  'Net ($M in 2024)': -0.4788719,
}, {
  Year: 2016,
  Sport: 'Non-program specific',
  'Net ($)': -12285027.0,
  'Net ($M)': -12.285027,
  'Net ($ in 2024)': -15970535.1000000015,
  'Net ($M in 2024)': -15.9705351,
}, {
  Year: 2016,
  Sport: "Other men's sports",
  'Net ($)': -3552642.0,
  'Net ($M)': -3.552642,
  'Net ($ in 2024)': -4618434.6000000015,
  'Net ($M in 2024)': -4.6184346,
}, {
  Year: 2016,
  Sport: "Other women's sports",
  'Net ($)': -11612762.0,
  'Net ($M)': -11.612762,
  'Net ($ in 2024)': -15096590.6000000015,
  'Net ($M in 2024)': -15.0965906,
}, {
  Year: 2016,
  Sport: "Women's basketball",
  'Net ($)': -2855955.0,
  'Net ($M)': -2.855955,
  'Net ($ in 2024)': -3712741.5,
  'Net ($M in 2024)': -3.7127415,
}, {
  Year: 2017,
  Sport: 'Football',
  'Net ($)': 7097242.0,
  'Net ($M)': 7.097242,
  'Net ($ in 2024)': 9084469.7599999979,
  'Net ($M in 2024)': 9.08446976,
}, {
  Year: 2017,
  Sport: "Men's basketball",
  'Net ($)': 2687725.0,
  'Net ($M)': 2.687725,
  'Net ($ in 2024)': 3440288.0,
  'Net ($M in 2024)': 3.440288,
}, {
  Year: 2017,
  Sport: 'Non-program specific',
  'Net ($)': -7231304.0,
  'Net ($M)': -7.231304,
  'Net ($ in 2024)': -9256069.1200000048,
  'Net ($M in 2024)': -9.25606912,
}, {
  Year: 2017,
  Sport: "Other men's sports",
  'Net ($)': -2738796.0,
  'Net ($M)': -2.738796,
  'Net ($ in 2024)': -3505658.879999999,
  'Net ($M in 2024)': -3.50565888,
}, {
  Year: 2017,
  Sport: "Other women's sports",
  'Net ($)': -12615426.0,
  'Net ($M)': -12.615426,
  'Net ($ in 2024)': -16147745.2800000012,
  'Net ($M in 2024)': -16.14774528,
}, {
  Year: 2017,
  Sport: "Women's basketball",
  'Net ($)': -3182651.0,
  'Net ($M)': -3.182651,
  'Net ($ in 2024)': -4073793.2800000003,
  'Net ($M in 2024)': -4.07379328,
}, {
  Year: 2018,
  Sport: 'Football',
  'Net ($)': -6880520.0,
  'Net ($M)': -6.88052,
  'Net ($ in 2024)': -8531844.799999997,
  'Net ($M in 2024)': -8.5318448,
}, {
  Year: 2018,
  Sport: "Men's basketball",
  'Net ($)': 1445153.0,
  'Net ($M)': 1.445153,
  'Net ($ in 2024)': 1791989.7200000007,
  'Net ($M in 2024)': 1.79198972,
}, {
  Year: 2018,
  Sport: 'Non-program specific',
  'Net ($)': 6585608.0,
  'Net ($M)': 6.585608,
  'Net ($ in 2024)': 8166153.9200000018,
  'Net ($M in 2024)': 8.16615392,
}, {
  Year: 2018,
  Sport: "Other men's sports",
  'Net ($)': -3312918.0,
  'Net ($M)': -3.312918,
  'Net ($ in 2024)': -4108018.3200000003,
  'Net ($M in 2024)': -4.10801832,
}, {
  Year: 2018,
  Sport: "Other women's sports",
  'Net ($)': -13741539.0,
  'Net ($M)': -13.741539,
  'Net ($ in 2024)': -17039508.3599999994,
  'Net ($M in 2024)': -17.03950836,
}, {
  Year: 2018,
  Sport: "Women's basketball",
  'Net ($)': -3406929.0,
  'Net ($M)': -3.406929,
  'Net ($ in 2024)': -4224591.96,
  'Net ($M in 2024)': -4.22459196,
}, {
  Year: 2019,
  Sport: 'Football',
  'Net ($)': -875710.0,
  'Net ($M)': -0.87571,
  'Net ($ in 2024)': -1068366.1999999955,
  'Net ($M in 2024)': -1.0683662,
}, {
  Year: 2019,
  Sport: "Men's basketball",
  'Net ($)': 1512791.0,
  'Net ($M)': 1.512791,
  'Net ($ in 2024)': 1845605.0200000014,
  'Net ($M in 2024)': 1.84560502,
}, {
  Year: 2019,
  Sport: 'Non-program specific',
  'Net ($)': 2197909.0,
  'Net ($M)': 2.197909,
  'Net ($ in 2024)': 2681448.9800000042,
  'Net ($M in 2024)': 2.68144898,
}, {
  Year: 2019,
  Sport: "Other men's sports",
  'Net ($)': -5263635.0,
  'Net ($M)': -5.263635,
  'Net ($ in 2024)': -6421634.7000000011,
  'Net ($M in 2024)': -6.4216347,
}, {
  Year: 2019,
  Sport: "Other women's sports",
  'Net ($)': -13314931.0,
  'Net ($M)': -13.314931,
  'Net ($ in 2024)': -16244215.8199999984,
  'Net ($M in 2024)': -16.24421582,
}, {
  Year: 2019,
  Sport: "Women's basketball",
  'Net ($)': -3432401.0,
  'Net ($M)': -3.432401,
  'Net ($ in 2024)': -4187529.2199999997,
  'Net ($M in 2024)': -4.18752922,
}, {
  Year: 2020,
  Sport: 'Football',
  'Net ($)': 4905945.0,
  'Net ($M)': 4.905945,
  'Net ($ in 2024)': 5936193.4499999955,
  'Net ($M in 2024)': 5.93619345,
}, {
  Year: 2020,
  Sport: "Men's basketball",
  'Net ($)': 190113.0,
  'Net ($M)': 0.190113,
  'Net ($ in 2024)': 230036.7300000004,
  'Net ($M in 2024)': 0.23003673,
}, {
  Year: 2020,
  Sport: 'Non-program specific',
  'Net ($)': 16015394.0,
  'Net ($M)': 16.015394,
  'Net ($ in 2024)': 19378626.7399999946,
  'Net ($M in 2024)': 19.37862674,
}, {
  Year: 2020,
  Sport: "Other men's sports",
  'Net ($)': -3021530.0,
  'Net ($M)': -3.02153,
  'Net ($ in 2024)': -3656051.3000000007,
  'Net ($M in 2024)': -3.6560513,
}, {
  Year: 2020,
  Sport: "Other women's sports",
  'Net ($)': -11655077.0,
  'Net ($M)': -11.655077,
  'Net ($ in 2024)': -14102643.1700000018,
  'Net ($M in 2024)': -14.10264317,
}, {
  Year: 2020,
  Sport: "Women's basketball",
  'Net ($)': -3219716.0,
  'Net ($M)': -3.219716,
  'Net ($ in 2024)': -3895856.3599999994,
  'Net ($M in 2024)': -3.89585636,
}, {
  Year: 2021,
  Sport: 'Football',
  'Net ($)': -869752.0,
  'Net ($M)': -0.869752,
  'Net ($ in 2024)': -1000214.8000000007,
  'Net ($M in 2024)': -1.0002148,
}, {
  Year: 2021,
  Sport: "Men's basketball",
  'Net ($)': -972723.0,
  'Net ($M)': -0.972723,
  'Net ($ in 2024)': -1118631.4500000002,
  'Net ($M in 2024)': -1.11863145,
}, {
  Year: 2021,
  Sport: 'Non-program specific',
  'Net ($)': 19449534.0,
  'Net ($M)': 19.449534,
  'Net ($ in 2024)': 22366964.1000000015,
  'Net ($M in 2024)': 22.3669641,
}, {
  Year: 2021,
  Sport: "Other men's sports",
  'Net ($)': -825244.0,
  'Net ($M)': -0.825244,
  'Net ($ in 2024)': -949030.5999999996,
  'Net ($M in 2024)': -0.9490306,
}, {
  Year: 2021,
  Sport: "Other women's sports",
  'Net ($)': -10773779.0,
  'Net ($M)': -10.773779,
  'Net ($ in 2024)': -12389845.8499999978,
  'Net ($M in 2024)': -12.38984585,
}, {
  Year: 2021,
  Sport: "Women's basketball",
  'Net ($)': -2549755.0,
  'Net ($M)': -2.549755,
  'Net ($ in 2024)': -2932218.25,
  'Net ($M in 2024)': -2.93221825,
}, {
  Year: 2022,
  Sport: 'Football',
  'Net ($)': 10457739.0,
  'Net ($M)': 10.457739,
  'Net ($ in 2024)': 10980625.950000003,
  'Net ($M in 2024)': 10.98062595,
}, {
  Year: 2022,
  Sport: "Men's basketball",
  'Net ($)': 954846.0,
  'Net ($M)': 0.954846,
  'Net ($ in 2024)': 1002588.2999999998,
  'Net ($M in 2024)': 1.0025883,
}, {
  Year: 2022,
  Sport: 'Non-program specific',
  'Net ($)': 15798447.0,
  'Net ($M)': 15.798447,
  'Net ($ in 2024)': 16588369.3500000015,
  'Net ($M in 2024)': 16.58836935,
}, {
  Year: 2022,
  Sport: "Other men's sports",
  'Net ($)': -5227954.0,
  'Net ($M)': -5.227954,
  'Net ($ in 2024)': -5489351.7000000002,
  'Net ($M in 2024)': -5.4893517,
}, {
  Year: 2022,
  Sport: "Other women's sports",
  'Net ($)': -14368396.0,
  'Net ($M)': -14.368396,
  'Net ($ in 2024)': -15086815.8000000007,
  'Net ($M in 2024)': -15.0868158,
}, {
  Year: 2022,
  Sport: "Women's basketball",
  'Net ($)': -3888351.0,
  'Net ($M)': -3.888351,
  'Net ($ in 2024)': -4082768.5500000003,
  'Net ($M in 2024)': -4.08276855,
}, {
  Year: 2023,
  Sport: 'Football',
  'Net ($)': -777066.0,
  'Net ($M)': -0.777066,
  'Net ($ in 2024)': -792607.3200000003,
  'Net ($M in 2024)': -0.79260732,
}, {
  Year: 2023,
  Sport: "Men's basketball",
  'Net ($)': -1631378.0,
  'Net ($M)': -1.631378,
  'Net ($ in 2024)': -1664005.5600000005,
  'Net ($M in 2024)': -1.66400556,
}, {
  Year: 2023,
  Sport: 'Non-program specific',
  'Net ($)': 19427715.0,
  'Net ($M)': 19.427715,
  'Net ($ in 2024)': 19816269.3000000045,
  'Net ($M in 2024)': 19.8162693,
}, {
  Year: 2023,
  Sport: "Other men's sports",
  'Net ($)': -5739860.0,
  'Net ($M)': -5.73986,
  'Net ($ in 2024)': -5854657.1999999993,
  'Net ($M in 2024)': -5.8546572,
}, {
  Year: 2023,
  Sport: "Other women's sports",
  'Net ($)': -15624888.0,
  'Net ($M)': -15.624888,
  'Net ($ in 2024)': -15937385.7600000016,
  'Net ($M in 2024)': -15.93738576,
}, {
  Year: 2023,
  Sport: "Women's basketball",
  'Net ($)': -4437060.0,
  'Net ($M)': -4.43706,
  'Net ($ in 2024)': -4525801.2000000002,
  'Net ($M in 2024)': -4.5258012,
}, {
  Year: 2002,
  'Net ($)': -246759.0099999998,
  'Net ($M)': -0.24675901,
  'Net ($ in 2024)': -429360.6773999976,
  'Net ($M in 2024)': -0.4293606774,
  Sport: 'Total',
}, {
  Year: 2003,
  'Net ($)': -4407885.0,
  'Net ($M)': -4.407885,
  'Net ($ in 2024)': -7493404.4999999925,
  'Net ($M in 2024)': -7.4934045,
  Sport: 'Total',
}, {
  Year: 2004,
  'Net ($)': -2195672.8200000003,
  'Net ($M)': -2.19567282,
  'Net ($ in 2024)': -3622860.1529999971,
  'Net ($M in 2024)': -3.622860153,
  Sport: 'Total',
}, {
  Year: 2005,
  'Net ($)': -7887610.0,
  'Net ($M)': -7.88761,
  'Net ($ in 2024)': -12699052.0999999996,
  'Net ($M in 2024)': -12.6990521,
  Sport: 'Total',
}, {
  Year: 2006,
  'Net ($)': -5278281.0,
  'Net ($M)': -5.278281,
  'Net ($ in 2024)': -8128552.7400000039,
  'Net ($M in 2024)': -8.12855274,
  Sport: 'Total',
}, {
  Year: 2007,
  'Net ($)': 2.0,
  'Net ($M)': 0.000002,
  'Net ($ in 2024)': 3.0,
  'Net ($M in 2024)': 0.000003,
  Sport: 'Total',
}, {
  Year: 2008,
  'Net ($)': 50750.0,
  'Net ($M)': 0.05075,
  'Net ($ in 2024)': 72572.4999999995,
  'Net ($M in 2024)': 0.0725725,
  Sport: 'Total',
}, {
  Year: 2009,
  'Net ($)': -1589165.0,
  'Net ($M)': -1.589165,
  'Net ($ in 2024)': -2304289.2499999963,
  'Net ($M in 2024)': -2.30428925,
  Sport: 'Total',
}, {
  Year: 2010,
  'Net ($)': -519105.1000000015,
  'Net ($M)': -0.5191051,
  'Net ($ in 2024)': -742320.2929999908,
  'Net ($M in 2024)': -0.742320293,
  Sport: 'Total',
}, {
  Year: 2011,
  'Net ($)': 181166.0,
  'Net ($M)': 0.181166,
  'Net ($ in 2024)': 250009.0800000075,
  'Net ($M in 2024)': 0.25000908,
  Sport: 'Total',
}, {
  Year: 2012,
  'Net ($)': 136921.7199999965,
  'Net ($M)': 0.13692172,
  'Net ($ in 2024)': 186213.5391999949,
  'Net ($M in 2024)': 0.1862135392,
  Sport: 'Total',
}, {
  Year: 2013,
  'Net ($)': 1480424.0,
  'Net ($M)': 1.480424,
  'Net ($ in 2024)': 1983768.1599999983,
  'Net ($M in 2024)': 1.98376816,
  Sport: 'Total',
}, {
  Year: 2014,
  'Net ($)': -3329368.0,
  'Net ($M)': -3.329368,
  'Net ($ in 2024)': -4361472.0799999954,
  'Net ($M in 2024)': -4.36147208,
  Sport: 'Total',
}, {
  Year: 2015,
  'Net ($)': -8476638.0,
  'Net ($M)': -8.476638,
  'Net ($ in 2024)': -11104395.7800000012,
  'Net ($M in 2024)': -11.10439578,
  Sport: 'Total',
}, {
  Year: 2016,
  'Net ($)': -21728744.0,
  'Net ($M)': -21.728744,
  'Net ($ in 2024)': -28247367.1999999955,
  'Net ($M in 2024)': -28.2473672,
  Sport: 'Total',
}, {
  Year: 2017,
  'Net ($)': -15983210.0,
  'Net ($M)': -15.98321,
  'Net ($ in 2024)': -20458508.8000000082,
  'Net ($M in 2024)': -20.4585088,
  Sport: 'Total',
}, {
  Year: 2018,
  'Net ($)': -19311145.0,
  'Net ($M)': -19.311145,
  'Net ($ in 2024)': -23945819.799999997,
  'Net ($M in 2024)': -23.9458198,
  Sport: 'Total',
}, {
  Year: 2019,
  'Net ($)': -19175977.0,
  'Net ($M)': -19.175977,
  'Net ($ in 2024)': -23394691.9399999902,
  'Net ($M in 2024)': -23.39469194,
  Sport: 'Total',
}, {
  Year: 2020,
  'Net ($)': 3215129.0,
  'Net ($M)': 3.215129,
  'Net ($ in 2024)': 3890306.0899999887,
  'Net ($M in 2024)': 3.89030609,
  Sport: 'Total',
}, {
  Year: 2021,
  'Net ($)': 3458281.0,
  'Net ($M)': 3.458281,
  'Net ($ in 2024)': 3977023.1500000041,
  'Net ($M in 2024)': 3.97702315,
  Sport: 'Total',
}, {
  Year: 2022,
  'Net ($)': 3726331.0,
  'Net ($M)': 3.726331,
  'Net ($ in 2024)': 3912647.5500000049,
  'Net ($M in 2024)': 3.91264755,
  Sport: 'Total',
}, {
  Year: 2023,
  'Net ($)': -8782537.0,
  'Net ($M)': -8.782537,
  'Net ($ in 2024)': -8958187.7399999984,
  'Net ($M in 2024)': -8.95818774,
  Sport: 'Total',
}];

export default data;
